import React from 'react';

const WhatWeDo = () => {
    return (
        <div class="hero mt-6 mb-16">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/NpbsjVk/Frame-27-3.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">What<span className='text-secondary'>We Do?</span> </h1>
               
                  <div class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">
                    <h2 className='font-medium '>Abroad counselling</h2>
                    <p>Dream Associates specializes in providing comprehensive career counseling services tailored to meet the unique needs and aspirations of each student.</p>
                    <h2 className='font-medium '>Course advice</h2>
                    <p>From initial consultations to in-depth assessments of academic strengths and career goals, we assist students in selecting the right country and university.
</p>
                    <h2 className='font-medium '>Visa application assistance</h2>
                    <p>Lorem ipsum dolor sit amet consectetur. Cursus amet aliquet urna euismod neque integer nulla vitae. Maecenas enim.</p>
                    <h2 className='font-medium '>Pre-departure Support</h2>
                    <p>Lorem ipsum dolor sit amet consectetur. Cursus amet aliquet urna euismod neque integer nulla vitae. Maecenas enim.</p>
                    <h2 className='font-medium '>Welcome events</h2>
                    <p>Lorem ipsum dolor sit amet consectetur. Cursus amet aliquet urna euismod neque integer..</p>
                  </div>
               
                </div>
          </div>
        </div>
      </div>
    );
};

export default WhatWeDo;